export const createAnalyticsTableColumns = (definitionColumns, groupBy) => {
    return definitionColumns.map((column) => {
        if (column.key === 'date' && groupBy) {
            column.label =
                {
                    hour: 'Hour',
                    day: 'Day',
                    month: 'Month',
                }[groupBy] ?? 'Date';
        }
        return {
            id: column.key,
            label: column.label,
            type: column.type,
            tooltip: column.tooltip
                ? {
                    title: 'title' in column.tooltip ? column.tooltip.title : undefined,
                    description: column.tooltip.description,
                    type: column.tooltip.formatType,
                }
                : undefined,
            breakdown: column.breakdown
                ? {
                    label: column.breakdown.label ?? undefined,
                    elements: column.breakdown.elements.map((element) => {
                        return {
                            id: element.key,
                            label: element.label,
                        };
                    }),
                }
                : undefined,
        };
    });
};
